import {
  ElementRef,
  AfterViewInit,
  Component,
  OnInit,
  ViewChild,
  NgModule,
  Inject,
} from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { FotoDialogComponent } from "app/shared/foto-dialog/foto-dialog.component";
import { Medico } from "app/models/medico.interface";
import { TelefonoPais } from "app/models/telefonoPais.interface";
import { FormGroup, FormControl, Validator, Validators } from "@angular/forms";
import { TelefonoPaisService } from "app/services/telefono-pais.service";
import { AbstractControl } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NotificationComponent } from "../notification/notification.component";
import { MedicoService } from "app/services/medico.service";
import { EstudioMedicoService } from "app/services/estudio-medico.service";
import { CentroMedicoService } from "app/services/centro-medico.service";
import { TipoDocumentoService } from "app/services/tipo-documento.service";
import { TipoDocumento } from "app/models/tipoDocumento.interface";
import { SpinnerService } from "app/services/spinner.service";
import { NgxMaterialTimepickerTheme } from "ngx-material-timepicker";
import { validateAgendaHorarios, DIAS } from "../../panel-seccion/medico/agenda-form/utils/agenda-validators";
import { camposFaltantes, mensajeError } from "app/utils/form-errors.utils";

@Component({
  selector: "app-medico-form-dialog",
  templateUrl: "./medico-form-dialog.component.html",
  styleUrls: ["./medico-form-dialog.component.scss"],
})
export class MedicoFormDialogComponent implements OnInit {
  @ViewChild("divImagen") divImagen: ElementRef;
  @ViewChild("UploadFileInput") uploadFileInput: ElementRef;
  public telPais: FormControl = new FormControl();
  public celPais: FormControl = new FormControl();
  myfilename = "Seleccionar Archivo";
  imagen = "";
  nameImage: string = "";
  medico: Medico;
  file: File = null;
  telefonoPais: TelefonoPais[];
  filtroTelefonoPais: TelefonoPais[] = [];
  filtroCelularPais: TelefonoPais[] = [];
  tiposDocumentos: TipoDocumento[];
  provincias: any[] = [];
  response: any;
  agenda: any;
  responseCreate: any;
  errorNumeroDocumento: any;
  errorDocumento: any;
  errorMatricula: any;
  errorTipoDocumento: any;
  errorEmail: any;
  errorAgenda: any;
  checked = false;
  disabled = false;
  darkTheme: NgxMaterialTimepickerTheme = {
    container: {
      bodyBackgroundColor: "#ffffff",
      buttonColor: "#000000",
    },
    dial: {
      dialBackgroundColor: "#3434EC",
    },
    clockFace: {
      clockFaceBackgroundColor: "#EEEEEE",
      clockHandColor: "#05CE7C",
      clockFaceTimeInactiveColor: "#3434EC",
    },
  };
  public telPaisBuscador: FormControl = new FormControl();
  public celPaisBuscador: FormControl = new FormControl();
  medicoForm = new FormGroup(
    {
      title: new FormControl(""),
      name: new FormControl("", [
        Validators.required,
        Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/),
      ]),
      surname: new FormControl("", [
        Validators.required,
        Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/),
      ]),
      tipoDocumento: new FormControl(""),
      numeroDocumento: new FormControl(""),
      matricula: new FormControl("", [
        Validators.required,
        Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/),
      ]),
      email: new FormControl("", Validators.email),
      telPais: new FormControl(""),
      telPaisBuscador: new FormControl(""),
      telCaract: new FormControl(""),
      telNumero: new FormControl(""),
      celPais: new FormControl(""),
      celPaisBuscador: new FormControl(""),
      celCaract: new FormControl(""),
      celNumero: new FormControl(""),
      codigoInterno: new FormControl(""),
      memberContactNo: new FormControl(""),
      notificaciones: new FormControl(true),
      password: new FormControl(""),
      repeatPassword: new FormControl(""),
      agenda: new FormControl(false),
      color_agenda: new FormControl("#000ec4"),
      lunesDesde: new FormControl(""),
      lunesHasta: new FormControl(""),
      lunesDesde2: new FormControl(""),
      lunesHasta2: new FormControl(""),
      martesDesde: new FormControl(""),
      martesHasta: new FormControl(""),
      martesDesde2: new FormControl(""),
      martesHasta2: new FormControl(""),
      miercolesDesde: new FormControl(""),
      miercolesHasta: new FormControl(""),
      miercolesDesde2: new FormControl(""),
      miercolesHasta2: new FormControl(""),
      juevesDesde: new FormControl(""),
      juevesHasta: new FormControl(""),
      juevesDesde2: new FormControl(""),
      juevesHasta2: new FormControl(""),
      viernesDesde: new FormControl(""),
      viernesHasta: new FormControl(""),
      viernesDesde2: new FormControl(""),
      viernesHasta2: new FormControl(""),
      sabadoDesde: new FormControl(""),
      sabadoHasta: new FormControl(""),
      sabadoDesde2: new FormControl(""),
      sabadoHasta2: new FormControl(""),
      domingoDesde: new FormControl(""),
      domingoHasta: new FormControl(""),
      domingoDesde2: new FormControl(""),
      domingoHasta2: new FormControl(""),
      licenseType: new FormControl(""),
      province: new FormControl(""),
      addressStreet: new FormControl(""),
      addressNumber: new FormControl(""),
    },
    [
      this.passwordMatchValidator,
      validateAgendaHorarios,
      this.validarAgendaHabilitadaConHorarios,
    ],
  );

  constructor(
    public fotoDialog: MatDialog,
    public dialogRef: MatDialogRef<MedicoFormDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private apiTel: TelefonoPaisService,
    private medicoService: MedicoService,
    private spinnerService: SpinnerService,
    private snackBar: MatSnackBar,
    private apiTipoDocumento: TipoDocumentoService,
  ) {}

  //
  ngOnInit(): void {
    this.formularioMedico();
  }

  //
  passwordMatchValidator(g: FormGroup) {
    return g.get("password").value === g.get("repeatPassword").value
      ? null
      : { mismatch: true };
  }

  validarAgendaHabilitadaConHorarios(g: FormGroup) {
    if (g.get("agenda")?.value !== true) return null;
    const algunoCargado = DIAS.some((d) =>
      g.get(`${d}Desde`)?.value || g.get(`${d}Hasta`)?.value ||
      g.get(`${d}Desde2`)?.value || g.get(`${d}Hasta2`)?.value,
    );
    return algunoCargado ? null : { fechasError: true };
  }

  //
  borrarFecha(fecha: any) {
    this.medicoForm.patchValue({
      [fecha]: "",
    });
  }

  //
  formularioMedico() {
    this.telefonoPais = this.data.listaTelefonoPais;
    this.filtroTelefonoPais = this.data.listaTelefonoPais;
    this.filtroCelularPais = this.data.listaTelefonoPais;
    this.tiposDocumentos = this.data.listaTipoDocumento;

    this.medicoService.getProvincias().subscribe({
      next: (data: any) => {
        this.provincias = data || [];
      },
      error: () => {
        this.provincias = [];
      },
    });
  }

  //
  filtrarTelPais(event?: any) {
    let textBuscador: string = this.telPaisBuscador.value;
    this.filtroTelefonoPais = this.telefonoPais.filter(function (element) {
      if (element.nombre.toUpperCase().includes(textBuscador.toUpperCase())) {
        return element;
      }
    });
  }

  //
  filtrarCelPais(event?: any) {
    let textBuscador: string = this.celPaisBuscador.value;
    this.filtroCelularPais = this.telefonoPais.filter(function (element) {
      if (element.nombre.toUpperCase().includes(textBuscador.toUpperCase())) {
        return element;
      }
    });
  }

  //
  crearMedico(form: Medico) {
    if (this.medicoForm.valid) {
      this.spinnerService.mostrarSpinner();
      this.medicoService.crear(this.nameImage, form, this.file).subscribe(
        (data) => {
          let response: any = data;
          if (response.statusError) {
            this.errorNumeroDocumento = response.errorNumeroDocumento;
            this.errorTipoDocumento = response.errorTipoDocumento;
            this.errorDocumento = response.errorDocumento;
            this.errorMatricula = response.errorMatricula;
            this.errorEmail = response.errorEmail;
            this.errorAgenda = response.errorAgenda;
            this.spinnerService.ocultarSpinner();
            this.openSnackBar("Guardado fallido", "error");
          } else {
            this.openSnackBar("Guardado exitoso", "exito");
            this.resetearFormulario();
            this.onClickNo();
          }
        },
        (error) => {
          this.spinnerService.ocultarSpinner();
          this.openSnackBar(mensajeError(error, "Guardado fallido"), "error");
        },
      );
    } else {
      this.openSnackBar(
        camposFaltantes(this.medicoForm, {
          name: "Nombre",
          surname: "Apellido",
          matricula: "Matricula",
        }),
        "error"
      );
    }
  }

  //
  resetearFormulario() {
    this.medicoForm.reset();
  }

  //
  clearNumeroDocumento() {
    this.errorNumeroDocumento = false;
    this.errorDocumento = false;
  }

  //
  clearTipoDocumento() {
    this.errorTipoDocumento = false;
    this.errorDocumento = false;
  }

  //
  clearMatricula() {
    this.errorMatricula = false;
  }

  //
  clearEmail() {
    this.errorEmail = false;
  }

  cambiarAgenda = (event) => {
    this.agenda = event.checked;
    this.errorAgenda = false;
  };

  //
  fileChangeEvent(event: any) {
    var target = event.target || event.srcElement;
  }

  //
  openDialogFoto() {
    const dialogRef = this.fotoDialog.open(FotoDialogComponent, {
      width: "50%",
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res.data == "" && res.img == "") {
      } else {
        if (
          res.data.id == "ico_paciente.png" ||
          res.data.id == "ico_pacienteM.png"
        ) {
          this.myfilename = res.data.id;
          this.imagen = "assets/img/" + res.data.id + "";
          this.nameImage = res.data.id;
          this.divImagen.nativeElement.style.display = "block";
        } else {
          this.myfilename = res.data.name;
          this.imagen = res.img;
          this.divImagen.nativeElement.style.display = "block";
          this.file = res.data;
          this.nameImage = "";
        }
      }
    });
  }

  //
  onClickNo() {
    this.dialogRef.close(true);
  }

  //
  openSnackBar(message: string, action: string) {
    this.snackBar.openFromComponent(NotificationComponent, {
      data: {
        message: message,
        action: action,
      },
      duration: 2500,
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: [action],
    });
  }
}
